import { DomainSheet } from "@/components/domain";
import { createFileRoute } from "@tanstack/react-router";
import { ReservationFulfillments } from "./(fulfillments)/-components/create-fulfillment";

export const Route = createFileRoute(
  "/(reservations)/reservations/$id/fulfillments/new/hotel/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = Route.useNavigate();

  return (
    <DomainSheet
      noOutlet
      onClose={() => {
        navigate({ to: "/reservations/$id/fulfillments" });
      }}
    >
      <ReservationFulfillments id={id} domain="hotel" />
    </DomainSheet>
  );
}
